<span *ngIf="age() == null" class="rv-danger">
  No utilization data in Rivet.
</span>
<span
  *ngIf="age() != null"
  class="rv-danger"
  [class.rv-caution]="age()! < 62"
  [class.rv-safety]="age()! < 32"
>
  Utilization data is {{ age() }} {{ age() | i18nPlural: dayPluralMap }} old.
</span>
<a
  class="rv-link"
  [routerLink]="'/settings/usage/import' | accountRoot"
  [queryParams]="{ next: location.path() }"
>
  Upload now.
</a>
